export default __webpack_public_path__ + "static/media/Search-small.a84c0e35.svg";